import { render } from "./BackHomeNav.vue?vue&type=template&id=5f404a0e&scoped=true"
import script from "./BackHomeNav.vue?vue&type=script&lang=js"
export * from "./BackHomeNav.vue?vue&type=script&lang=js"

import "./BackHomeNav.vue?vue&type=style&index=0&id=5f404a0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f404a0e"]])

export default __exports__